export const SET_SHOULD_FETCH_ESSENTIAL_DATA = 'ESSENTIAL-DATA/SET_SHOULD_FETCH_CONFIGURATIONS' as const;
export const SET_ACTION_STATUS = 'ESSENTIAL_DATA/SET_ACTION_STATUS' as const;
export const RESET_ACTION_STATUSES = 'ESSENTIAL_DATA/RESET_ACTION_STATUSES' as const;
export const SET_LAST_SYNC_TIMESTAMP = 'ESSENTIAL_DATA/SET_LAST_SYNC_TIMESTAMP' as const;
